import { render, staticRenderFns } from "./handleFinalSettlement.vue?vue&type=template&id=2b199752&scoped=true"
import script from "./handleFinalSettlement.vue?vue&type=script&lang=js"
export * from "./handleFinalSettlement.vue?vue&type=script&lang=js"
import style0 from "./handleFinalSettlement.vue?vue&type=style&index=0&id=2b199752&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b199752",
  null
  
)

export default component.exports